module.exports = __webpack_public_path__ + "static/media/danielle-lenee.f47462b9.md";